import { createMainMenuNodeFromEntry } from 'experiments/deeplinks-flow-feature/treatment/features/menu/utils/create-main-menu-node-from-entry';
import { EntryTypeEnum } from 'generated/graphql-gateway';
import { ILocalizedMenuEntry, IMainMenuNode } from 'state/unified-menu/types';
import { normalizeType } from 'state/unified-menu/utils';

/**
 * Resolves the section node to pin for Full Menu unavailable chrome.
 * Prefers catalog, then a catalog SECTION entry, then the store main-menu node
 * so an empty/daypart-filtered store section still recovers when catalog fails.
 */
export function resolveUnavailableSectionNode({
  unavailableSectionId,
  catalogSections,
  catalogEntries,
  storeSections,
}: {
  unavailableSectionId: string;
  catalogSections: readonly IMainMenuNode[];
  catalogEntries: readonly ILocalizedMenuEntry[];
  storeSections: readonly IMainMenuNode[];
}): IMainMenuNode | null {
  if (!unavailableSectionId) {
    return null;
  }

  const fromCatalog = catalogSections.find(section => section.id === unavailableSectionId);
  if (fromCatalog) {
    return fromCatalog;
  }

  const catalogEntry = catalogEntries.find(
    entry =>
      entry.id === unavailableSectionId &&
      normalizeType(entry.type) === normalizeType(EntryTypeEnum.SECTION)
  );
  if (catalogEntry) {
    return createMainMenuNodeFromEntry(catalogEntry);
  }

  return storeSections.find(section => section.id === unavailableSectionId) ?? null;
}
